import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="amount-amend"
export default class extends Controller {

  static targets = ['input', 'submit']

  connect() {
    if(this.inputTarget.value === '') {
      this.inputTarget.value = 0;
    }
  }

  decrease() {
    console.log('decrease')
    const submit = document.querySelector('input.btn');
    if(this.inputTarget.value > 0) {
      this.inputTarget.value--
      this.submit()
    }
  }

  increase() {
    console.log('indrease')
    // const submit = document.querySelector('input.btn'); 
    this.inputTarget.value++
    this.submit()
  }

  submit() {
    const submitEvent = new CustomEvent('submit', { bubbles: true, cancelable: true });
    this.inputTarget.form.dispatchEvent(submitEvent); 
  }
}
